import find from 'lib/sequence/component/children/find'
import { get } from 'lib/sequence/component/state/value'

/**
 * Organisation step action.
 *
 * Sets the step as completed if its required fields are filled.
 *
 * @param module the current module composition object
 */
export default (module: Gaia.AppModule.Spec) => component => async (...args) => {
  const stepState = component[G.STATE]
  const { name, street, zip, city, country } = find(component)

  stepState.completed = [name, street, zip, city, country].every(
    field => !!get(field),
  )

  stepState.confirmed = stepState.completed

  return args
}
